import React from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import { cbse } from "./data";
import FAQ from "./commonfaq";
import { cbseSchool } from "./faqdata";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";

const seopages = {
    title: "Best CBSE School in Hyderabad | Rankridge School",
    description:
      "best cbse school hyderabad, cbse schools in hyderabad, rankridge cbse school, top cbse school hyderabad, cbse curriculum schools hyderabad, affordable cbse schools hyderabad, cbse junior school hyderabad, cbse high school hyderabad, cbse secondary school hyderabad, cbse school admissions hyderabad, cbse with iit jee coaching hyderabad, cbse with neet coaching hyderabad, cbse private schools hyderabad, english medium cbse school hyderabad, cbse academic excellence hyderabad, cbse science schools hyderabad, cbse exam preparation hyderabad, best cbse results hyderabad, cbse extracurricular activities hyderabad, cbse holistic education hyderabad",
    canonical_path: "https://rankridgeschools.com/best-cbse-schools-in-hyderabad/",
    og_description: "",
    og_image: "",
  };
const title="  CBSE Programme at Rankridge"
 const description="Choosing the right CBSE school can set the tone for a child’s entire learning journey. At Rankridge Schools, our CBSE programme in Hyderabad focuses on building strong academic foundations, sharp thinking, and responsible citizenship. Recognized among the best CBSE schools in Hyderabad, we blend rigorous syllabus with real-world, hands-on learning to make education meaningful.From early grades through Grade 12, CBSE students benefit from well-structured curricula, expert teachers, and modern labs. Alongside core subjects, we emphasize co-curricular activities arts, sports, debates,that nurture creativity, teamwork, and confidence. For those planning ahead, our curricula align seamlessly with competitive exam preparation like IIT-JEE & NEET foundation, without compromising board exam readiness.At Rankridge, CBSE isn’t just about scores,it’s about shaping curious, resilient learners who are ready for challenges today and dreams tomorrow."

const CbseSchool = () => {
  return (
    <div> 
      <h1 className="text-center text-2xl font-bold m-3"> Best CBSE Schools in Hyderabad – Building Strong Foundations for Grades 1 to 10</h1>

     {/* <CommonImageSlider  images={cbse}/> */}
                    <CommonAboutHeader  images={cbse} title={title} des={description}/>
     
     <section className="mt-4 mb-4">
     <CallandRegisterComponent />
</section>
 {/*<h2 className="text-2xl text-center capitalize sm:text-2xl font-semibold text-[black]  m-2">  Building strong foundations for global success – Rankridge CBSE Curriculum School.
    </h2>

<section className="m-4">
  <h2 className="text-2xl font-bold text-center mb-4">
    About Rankridge CBSE Curriculum School
  </h2>
  <p className="text-gray-700 text-justify">
    At Rankridge School, we understand that the school years are the most formative phase of a child’s life. 
    Our CBSE curriculum from Grades 1 to 10 is carefully designed to nurture intellectual growth, develop creativity, 
    and build life skills that prepare students for a rapidly changing world. We focus on conceptual clarity, skill 
    development, and practical application so students are ready not just for exams, but for life beyond school. 
    Along with academics, we integrate personality development, leadership skills, and competitive exam readiness 
    to give students a clear advantage.
  </p>
</section> */}

<div className="bg-[#20b2aa] text-[#0e1b3d] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-12 space-y-16">
  {/* Tagline Section */}
  <div className="text-center max-w-4xl mx-auto">
    <h2 className="text-2xl font-semibold mb-3">
      Rankridge School – Building Strong Foundations, Shaping Brilliant Futures
    </h2>
    <h3 className="text-xl sm:text-2xl font-semibold mb-5">
      Hyderabad’s Best CBSE Curriculum Foundation School for Grades 1 to 10
    </h3>
    <p className="mb-3">
      Every parent dreams of giving their child the strongest possible start — not just in academics, but in life. 
      At Rankridge School, we turn that dream into reality through our CBSE Curriculum Foundation Program, designed 
      to empower students from Grades 1 to 10 with exceptional subject mastery, competitive exam readiness, 
      and all-round development.
    </p>
    <p>
      We believe that a strong CBSE foundation is the launchpad for success in IIT-JEE, NEET, NTSE, Olympiads, and beyond. 
      Our approach combines world-class academics with holistic growth, ensuring every child is confident, capable, 
      and future-ready.
    </p>
  </div>

  {/* Why Rankridge Section */}
  <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
    {[
      {
        title: "1. Strong Academic Foundation – Concept-Based Learning",
        content: [
          "At Rankridge, we go beyond rote memorization. Our CBSE curriculum foundation program in Hyderabad focuses on deep understanding of Mathematics, Science, English, and Social Science through activity-based, visual, and experiential learning.",
          "This ensures students can apply their knowledge in real-life situations and competitive exams alike.",
        ],
      },
      {
        title: "2. Early Competitive Exam Readiness",
        content: [
          "We believe early exposure to competitive exam techniques builds confidence. Our integrated CBSE coaching for IIT-JEE & NEET begins at the foundation level, helping students:",
          "Develop strong analytical and reasoning skills.",
          "Practice problem-solving from a young age.",
          "Prepare systematically for NTSE, Olympiads, and Science/Math Talent Exams.",
        ],
      },
      {
        title: "3. Expert Faculty – Mentors Who Inspire",
        content: [
          "Learning at Rankridge is powered by experienced, passionate, and result-oriented teachers. They provide:",
          "Personalized mentoring to track every child’s growth.",
          "Interactive doubt-clearing sessions to ensure clarity of concepts.",
          "Encouragement to excel academically while maintaining curiosity and creativity.",
        ],
      },
      {
        title: "4. World-Class Infrastructure for Modern Learning",
        content: [
          "We know that an inspiring environment leads to better learning outcomes:",
          "Digital Smart Classrooms for interactive sessions.",
          "Well-equipped Science and Computer Labs for hands-on learning.",
          "Safe, hygienic campus with CCTV surveillance for security.",
        ],
      },
      {
        title: "5. Holistic Development Beyond Academics",
        content: [
          "We nurture body, mind, and character through:",
          "Sports & fitness programs for physical well-being.",
          "Arts, music, and drama for creativity.",
          "Leadership and personality development sessions for confidence.",
          "Value-based education for strong ethics and discipline.",
        ],
      },
      {
        title: "6. Proven Excellence and Success Stories",
        content: [
          "Our alumni consistently excel in board exams and secure top positions in competitive tests.",
          "Parents choose us because Rankridge CBSE school admissions in Hyderabad promise not just education, but results backed by years of achievement.",
        ],
      },
    ].map((item, i) => (
      <div
        key={i}
        className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm"
      >
        <h3 className="text-lg font-bold mb-3 text-black">{item.title}</h3>
        <ul className="list-disc pl-6 space-y-1 text-gray-700">
          {item.content.map((c, j) => (
            <li key={j}>{c}</li>
          ))}
        </ul>
      </div>
    ))}
  </div>

  {/* Closing Section */}
  <div className="space-y-8">
    <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
      <h3 className="text-lg font-bold mb-2 text-black">
        A School That Grows With Your Child
      </h3>
      <p>
        From Grade 1 to Grade 10, our CBSE curriculum foundation program ensures your child is always ahead — 
        academically strong, exam-ready, and well-rounded in life skills.
      </p>
    </div>

    <div className="border bg-white border-gray-300 p-6 rounded-xl shadow-sm">
      <h3 className="text-lg font-bold mb-3 text-black">
        Admissions Open – Give Your Child the Rankridge Advantage
      </h3>
      <p>If you’re looking for:</p>
      <ul className="list-disc pl-6 mb-3">
        <li>Best CBSE foundation school in Hyderabad</li>
        <li>CBSE school with competitive exam coaching</li>
        <li>Olympiad preparation CBSE Hyderabad</li>
      </ul>
      <p className="font-semibold mt-4">
        📞 Call us today or 📍 Visit our campus to experience the Rankridge difference. 
        Let’s work together to shape your child’s bright, confident, and successful future.
      </p>
    </div>
  </div>
</div>


        <FAQ data={cbseSchool} />

                    <SeoMeta seopages={seopages} />

        </div>
  
  );
};
export default CbseSchool